import React, { FC, Fragment, useEffect, useRef, useState } from "react";
import "./instituteTeacherDetails.scss";
import faker from "faker";
import CardMenu from "../../../../../shared/components/CourseComponents/CardMenu";
import { ArrowLeftOutlined } from "@ant-design/icons";
import MailIcon from "../../../../../assets/icons/mail-blue-dark.svg";
import PhoneIcon from "../../../../../assets/icons/phone-blue-dark.svg";
import { Col, Row } from "antd";
import { useHistory, useParams } from "react-router-dom";
import Filters from "../../../../../shared/components/Filters";
import { Form, Formik, FormikValues } from "formik";
import DropdownField from "../../../../../shared/components/DropdownField";
import {
  Branches,
  BranchMetaModel,
} from "../../../../../models/InstituteModel/branches.model";
import BranchService from "../../../../../services/InstituteService/branch.service";
import { deserialize } from "serializr";
import { InstituteTutorModel } from "../../../../../models/InstituteModel/tutor.model";
import { InstituteTutorService } from "../../../../../services/InstituteService/tutor.service";
import InstituteTeacherForm from "../InstituteTeacherForm";
import DeleteAlert from "../../../../../shared/components/DeleteAlert";
import { LoadingComponent } from "../../../../../shared/components/LoadingComponent";
import ButtonComponent from "../../../../../shared/components/ButtonComponent";
import { TeacherPasswordForm } from "../TeacherPasswordForm";

interface InstituteTeacherDetailsProps {}

const InstituteTeacherDetails: FC<InstituteTeacherDetailsProps> = (props) => {
  const {} = props;
  const history = useHistory();
  const [teacher, setTeacher] = useState<InstituteTutorModel>({});
  const [loading, setLoading] = useState(false);
  const params: any = useParams();
  const [showForm, setFormVisibility] = useState(false);
  const [deleteVisible, setDeleteVisibility] = useState(false);
  const [showDrawer, setShowDrawer] = useState<boolean>(false);

  const fetchTutor = () => {
    setLoading(true);
    InstituteTutorService.fetchInstituteTutor(
      params?.teacherId,
      (teacher) => {
        setTeacher(teacher);
      },
      () => {},
      () => {
        setLoading(false);
      }
    );
  };

  useEffect(() => {
    fetchTutor();
  }, []);

  const refreshHandler = () => {
    fetchTutor();
  };

  const deleteTutor = () => {
    if (teacher?.id)
      InstituteTutorService.deleteInstituteTutor(
        teacher?.id,
        () => {
          setDeleteVisibility(false);
          history.goBack();
        },
        () => {},
        () => {}
      );
  };

  return loading ? (
    <LoadingComponent title="Fetching details..." />
  ) : (
    <div className="page-view institute-teacher-details">
      <InstituteTeacherForm
        visible={showForm}
        closeHandler={() => {
          setFormVisibility(false);
        }}
        data={teacher}
        refreshList={refreshHandler}
      />
      <DeleteAlert
        title={teacher?.fullName}
        detail={""}
        visible={deleteVisible}
        setVisible={setDeleteVisibility}
        deleteText="tutor"
        deleteWarning="This tutor will be deleted permanently"
        handleDelete={deleteTutor}
      />
      <div className="institute-teacher-details__header">
        <div className="header-left">
          <ArrowLeftOutlined onClick={() => history.goBack()} />
          {teacher?.displayPictureUrl ? (
            <img className="display-picture" src={teacher?.displayPictureUrl} />
          ) : (
            ""
          )}

          <div className="details">
            <h3>{teacher?.fullName}</h3>
            <p className="email">
              <img src={MailIcon} /> {teacher?.email}
            </p>
            <p className="phone-number">
              <img src={PhoneIcon} /> {teacher?.phoneNumber}
            </p>
          </div>
        </div>
        <div className="header-right">
          <CardMenu
            menuText="Teacher"
            handleEdit={() => {
              setFormVisibility(true);
            }}
            handleDelete={() => {
              setDeleteVisibility(true);
            }}
          />
        </div>
      </div>
      <div className="institute-teacher-details__content">
        <div className="branch-details">
          {/* <img src={faker.image.business()} /> */}
          <div className="branch-info-container">
            <div className="branch-name__container">
              <p className="branch__name">{teacher?.branch?.name}</p>
              <p className="institute__name">{teacher?.institute?.name}</p>
            </div>
            <ButtonComponent
              className='header-add-btn update-password-btn'
              buttonContent={'Update Password'}
              type='primary'
              onClick={() => {
                setShowDrawer(true);
              }}
            />
            <TeacherPasswordForm
                open={showDrawer}
                setOpen={setShowDrawer}
                onClose={() => setShowDrawer(false)}
                tutorData={teacher}
            />
          </div>
        </div>
        {teacher?.tutorClassRooms?.length ? (
          <Fragment>
            <Row className="class-details">
              <Col span={4}>
                <div className="head">Class</div>
              </Col>
              <Col span={4}>
                <div className="head">Sections</div>
              </Col>
              <Col span={16}>
                <div className="head">Subjects</div>
              </Col>
            </Row>
            {teacher?.tutorClassRooms?.map((classroom) => {
              return classroom?.tutorSections?.map((section) => {
                return (
                  <Row>
                    <Col span={4}>
                      <div className="value">
                        {classroom?.name}{" "}
                        {classroom?.classTeacher && (
                          <span className="class-teacher">Class Teacher</span>
                        )}
                      </div>
                    </Col>
                    <Col span={4}>
                      <div className="value">{section?.name}</div>
                    </Col>
                    <Col span={16}>
                      <div className="value">
                        {section?.tutorSubjects?.map((subject, index) => {
                          return `${subject?.name}${
                            section?.tutorSubjects?.length
                              ? section?.tutorSubjects?.length - 1 !== index
                                ? ", "
                                : ""
                              : ""
                          }`;
                        })}
                      </div>
                    </Col>
                  </Row>
                );
              });
            })}
          </Fragment>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default InstituteTeacherDetails;
